import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { GlobalTaxForm } from './global-taxform';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxIdHelpPopUpId, LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot, GlobalTaxIdCountryCodeToPilots, GlobalTaxIdPilots } from '../constants';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { addLegalIdentifierNumberInTaxSchema, withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getPilotStatus, getTaxTypeLabel } from '../utils';
import { EmptyTaxForm } from './empty-taxform';
import { CustomValidateItems } from '../validator';
import { AZTaxViewTaxForm } from './viewtaxforms/azerbaijan-viewtaxform';

const {
  CountryCode, TaxType, TaxAZVatNumberRegExp, TaxLabelFormat,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxAZVatNumberRegExp);

const taxSchemaGetter = ({ permissions }) => {
  const IsLegalIdentifierNumberPilotOn = getPilotStatus(LegalIdentifierNumberPilot, permissions);
  const taxSchema = {
    name: 'Azerbaijan Taxation Validation Schema',
    type: 'object',
    properties: {
      [TaxType.VatNumber]: {
        type: 'string',
        required: false,
        helpPopupTopic: GlobalTaxIdHelpPopUpId,
      },
    },
  };
  if (IsLegalIdentifierNumberPilotOn) {
    addLegalIdentifierNumberInTaxSchema(taxSchema);
  }
  return taxSchema;
};

const AzerbaijanTaxForm = ({
  i18n,
  data,
  mtData,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
  permissions,
}) => {
  const isRemoteSellerPilotOn = getPilotStatus(GlobalTaxIdPilots.RemoteSellerEnablementTaxIdCollection, permissions);
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(isRemoteSellerPilotOn ? CustomValidateItems.RemoteSellerAzerbaijanVATFormatValidation : CustomValidateItems.AzerbaijanVATFormatValidation), [i18n, isRemoteSellerPilotOn]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.AZ }, permissions), [i18n, permissions]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      // TODO: Remove showTaxFilePicker prop for all tax forms
      // showTaxFilePicker={showTaxFilePicker}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
      permissions={permissions}
      showLegalIdentifierNumberField
      legalIdentifierHint={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.AZ])}
    />
  );
};

AzerbaijanTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.AZ;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AzerbaijanTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AZTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/AZ/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
